export const sortCarsParams = new Map([
  ['ÐÐ°ÑÐºÐ°', 'mark'],
  ['ÐÐ¾Ð´ÐµÐ»Ñ', 'model'],
  ['ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ', 'complectation'],
  ['ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°', 'issueYear'],
  ['ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', 'city'],
  ['Ð¦Ð²ÐµÑ', 'color'],
  ['Ð Ð Ð¦, KZT', 'price'],
  ['Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', 'engine'],
]);

export const sortDealsParams = new Map([
  ['ÐÐ°ÑÐ°', 'date'],
  ['ÐÐ»Ð¸ÐµÐ½Ñ', 'clientId'],
  ['Ð¡ÑÐ¼Ð¼Ð° ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ°, KZT', 'sum'],
  ['Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸', 'statusId'],
  ['Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ', 'statusPaymentId'],
  ['ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ', 'initialFee'],
  ['Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ (Ð¼ÐµÑ)', 'period'],
  ['ÐÐ¶ÐµÐ¼ÐµÑÑÑÐ½ÑÐ¹ Ð¿Ð»Ð°ÑÐµÐ¶', 'monthlyPayment'],
]);

export const sortClientsParams = new Map([
  ['Ð¤ÐÐ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', 'fio'],
  ['ÐÐÐ', 'iin'],
  ['Ð¢ÐµÐ»ÐµÑÐ¾Ð½', 'phone'],
  ['E-mail', 'email'],
  ['ÐÐ¾ÑÐ¾Ð´', 'city'],
  ['Ð¯Ð·ÑÐº', 'language'],
  ['Ð¡ÑÐ°ÑÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸', 'notarial_verification'],
]);

export const sortLeadsParams = new Map([
  ['ÐÐ°ÑÐ°', 'date'],
  ['ÐÐ»Ð¸ÐµÐ½Ñ', 'client'],
  ['ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ', 'manager'],
  ['ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ', 'markAndModel'],
  ['ÐÑÑÐ¾ÑÐ½Ð¸Ðº', 'source'],
  ['Ð¢ÐµÐ»ÐµÑÐ¾Ð½', 'phone'],
  ['E-mail', 'email'],
  ['Ð¡ÑÐ°ÑÑÑ', 'status'],
]);
